import { ReactElement } from "react";
import { useAvatarUrl } from "../common/avatarStore";

interface AvatarSourceProps {
  employeeId?: string | null;
  enabled?: boolean;
  children: (src: string | null) => ReactElement;
}

/** Render-prop bridge so class components can read a cached profile photo (see avatarStore). */
export default function AvatarSource({
  employeeId,
  enabled = true,
  children,
}: AvatarSourceProps) {
  return children(useAvatarUrl(employeeId, enabled));
}
